import { useMemo } from 'react';
import { useAppContextStore } from 'scbk-services/shared-context/stores/appContextStore.ts';

import type { AppContext } from 'scbk-services/types/shared-context/app-context';

const useAppContext = () => {
    const context = useAppContextStore((state) => state.context);
    const resetAppContext = useAppContextStore((state) => state.resetAppContext);
    const setAppContext = useAppContextStore((state) => state.setAppContext);
    const updateAppContext = useAppContextStore((state) => state.updateAppContext);

    const getAppContext = (): AppContext.Context => {
        return useAppContextStore.getState().context;
    };

    return useMemo(
        () => ({
            getContext: getAppContext,
            resetContext: resetAppContext,
            setContext: setAppContext,
            updateContext: updateAppContext,
            seniorMode: context.seniorMode,
            isChangedSeniorMode: context.isChangedSeniorMode,
            darkMode: context.darkMode,
            initialized: context.initialized,
            osInfo: context.os,
            deviceInfo: context.device,
        }),
        [context, resetAppContext, setAppContext, updateAppContext],
    );
};

export default useAppContext;
